<div class="w-100 pt-3 text-center row-title">
    <div class="bold-text blue-color align-content-center w-100 pb-3 proc-title">activer une nouvelle carte
        sim {{ step }}/2
    </div>
</div>

@if (step === 1 && line.status.toLowerCase() !== 'active') {
    <div class="mt-5">
        <div class="w-100 text-center proc-buttons">
            <div>Pour activer une nouvelle carte sim, La ligne doit être active.</div>
        </div>
    </div>
}

@if (step === 1 && line.status.toLowerCase() == 'active') {
    <div>
        <div class="col-12">
            <div class="bold-label-text pb-3">Ligne : <span class="blue-text">{{ line.phoneNumber }}</span></div>
            <hr/>
        </div>
        @if (form && errorMessage == null) {
            <form class="form w-100" [formGroup]="form">
                <div>
                    <input type="text" formControlName="simCardNumber" placeholder="Numéro de carte SIM"
                           class="form-control"/>
                    @if (submitted && getError('simCardNumber')) {
                        <p class="error-msg">
                            {{ getError('simCardNumber') }}
                        </p>
                    }
                    @if (submitted && simCardErrorMessage) {
                        <p class="error-msg">{{ simCardErrorMessage }}</p>
                    }
                </div>
                <div class="row w-100 pt-3 text-center">
                    <div class="col-12 w-100 cta_container">
                        <button type="button" class="cta_cancel column" (click)="cancel()">Annuler<span></span></button>
                        <button type="submit" class="cta_btn level_2 column" (click)="checkSimCardNumber()">
                            Suivant<span></span></button>
                    </div>
                </div>
            </form>
        }
    </div>
}
@if (errorMessage != null && line.status.toLowerCase() == 'active') {
    <div>
        <div class="container pb-3 mt-5">
            <div class="msg-error">
                {{ errorMessage }}
            </div>
        </div>
        <div class="row w-100 pt-3 text-center">
            <div class="col-12 w-100 cta_container">
                <button type="button" class="cta_cancel column" (click)="cancel()">Annuler<span></span></button>
            </div>
        </div>
    </div>
}

@if (step === 2 && errorMessage == null) {
    <div>
        <div class="col-12">
            <div class="bold-text pb-3 mt-5 text-center"> Etes-vous sûr de vouloir activer la carte SIM
                <strong> {{ iccid }} </strong> pour cette ligne <strong> {{ line.phoneNumber }} </strong> ?
            </div>
        </div>
        <div class="row w-100 pt-3 text-center">
            <div class="col-12 w-100 cta_container">
                <button type="button" class="cta_cancel column" (click)="setStep(1)">Retour<span></span></button>
                <button type="button" class="cta_btn level_2 column" (click)="submit()">valider<span></span></button>
            </div>
        </div>
    </div>
}

